import React, {useEffect, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {getTypeContratPayment} from '../../../../common/utils/paiement';
import {
  ERROR_MESSAGE,
  LOADING_MESSAGE,
} from '../../../../data/constants/paiement';
import {formatDataForRapatriementRenewal} from '../../../../data/factory/paiement';
import {ApiResponse} from '../../../../data/types/interface/api';
import {ComptantServices} from '../../../../services/applicatif/comptant';
import {IComptant} from '../../../../services/bdl/comptant';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import Label from '../../../components/Label';
import LoaderWithMessage from '../../../components/LoaderWithMessage';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../../components/PageContainer';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ComptantPaymentForm = (props: any) => {
  const {user} = props;
  const {contratEC = {}} = props?.user || {};
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorModal, setShowErrorModal] = useState(false);
  const primTTC = contratEC.primeTTC || contratEC.montant || 0;
  const premierVersement = contratEC.premierVersement
    ? contratEC.premierVersement
    : 0;

  const [IsLoading, setIsLoading] = useState(false);
  const [numero, setNumero] = useState('');
  const {postComptant} = ComptantServices();

  const montant =
    contratEC.typeContrat === undefined &&
    contratEC.typePayment !== 'prime' &&
    contratEC.typePayment !== 'renouvellement'
      ? 0
      : contratEC.typeContrat === 'retraite'
      ? premierVersement
      : primTTC;

  const [loaderMessage] = useState(LOADING_MESSAGE);

  useEffect(() => {
    generateRegistre();
  }, []);

  const generateRegistre = async () => {
    const contrat = user?.contratEC?.typeContrat;

    const comptant: IComptant = {
      simulationId: '',
      typeContrat: '',
      montant: montant,
      typePayment: contratEC.typePayment,
      primeTTC: primTTC,
    };

    comptant.simulationId = contratEC.simulationId;
    if (contratEC.numeroPolice && contratEC.typePayment == 'renouvellement')
      comptant.numeroPolice = contratEC.numeroPolice;
    if (
      contrat === 'retraite' ||
      (contratEC.typeContratPayment === 'retraite' &&
        (contratEC.primeTTC === '' || contratEC.typeContrat === undefined))
    ) {
      comptant.typeContrat = 'retraite';
    } else {
      comptant.typeContrat = getTypeContratPayment(
        contrat,
        contratEC?.typeContratPayment,
      );
    }

    const extraInformation =
      contrat == 'rapatriement'
        ? formatDataForRapatriementRenewal(contratEC)
        : {};

    setIsLoading(true);
    postComptant({...comptant, ...extraInformation})
      .then((res: ApiResponse) => {
        if (!res?.isError && res.data) {
          setNumero(res.data.numero || '');
        } else {
          setErrorMessage(ERROR_MESSAGE);
          setShowErrorModal(true);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <View style={{backgroundColor: 'white'}}>
      <HeaderScreen
        title="Paiement par comptant"
        type="retour"
        noBreadcrumb={false}
      />
      <LoaderWithMessage
        isModal
        isLoading={IsLoading}
        message={loaderMessage}
      />
      <PageContainer>
        {!IsLoading && (
          <View>
            <View>
              <Label
                title={`Votre dossier a été enregistré avec succès. Pour finaliser votre souscription, nous vous invitons à vous rendre à l'agence que vous avez sélectionnée lors de votre souscription. Veuillez communiquer à l'agence le numéro de dossier ci-après ${numero} pour permettre la finalisation du processus. Merci `}
                type="mainTitle"
              />
            </View>
          </View>
        )}
        {showErrorModal && (
          <ConfirmationModal
            title="Erreur"
            content={errorMessage}
            btn1="OK"
            handleBtn1={() => setShowErrorModal(false)}
          />
        )}
      </PageContainer>
    </View>
  );
};

export const ComptantPayment = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ComptantPaymentForm);
